const TabSelector = ({ component, setComponent, tabName, label, handleClearResults }) => {

  const handleOnClick = () => {
    setComponent(tabName);
    handleClearResults();
  }

  return (
    <span
      className={component != tabName ? 'isSelected' : ''}
      onClick={handleOnClick}
    >
      {label}
    </span>
  );
};

export default TabSelector;